import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { createBrowserHistory } from "history";

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING,
    disableCookiesUsage: true,

    // Storage needs to be permanently disabled, as once it's enabled, it can't be disabled again.
    // It needs to be disabled for anyone who has rejected analytics cookies in the cookie banner.
    // See ticket 283307 for more details.
    isStorageUseDisabled: true,
    enableSessionStorageBuffer: false,

    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});
appInsights.loadAppInsights();
export { reactPlugin, appInsights };
